import css from './Loader.module.scss'
import React from 'react'
import BeatLoader from 'react-spinners/BeatLoader'
import classNames from 'classnames'

import { TICKETSMS_COLORS_RED } from 'utils/constants/colors'

interface IProps {
  fixed?: boolean
  children?: React.ReactNode
}

const Loader: React.FC<IProps> = ({ fixed = true, children }) => {
  return (
    <div className={classNames(css.layout_loader, { [css.fixed]: fixed })}>
      <div className={css.outside}>
        <section
          className={classNames(css.inside, { [css.withChildren]: React.Children.toArray(children).length > 0 })}
        >
          <BeatLoader color={TICKETSMS_COLORS_RED} />
          {React.Children.toArray(children)}
        </section>
      </div>
    </div>
  )
}

export default Loader
